/**
 * classStore.ts
 * Roster, XP, and star state for the active class session.
 */

import { create } from 'zustand';
import type { Student, StarAwardEvent } from '@types-local/class.types';

interface ClassState {
  // Sorted roster (by XP desc, maintained by Firestore onSnapshot)
  roster: Student[];
  setRoster: (students: Student[]) => void;

  // Pending level-up notifications (cleared after animation plays)
  pendingLevelUps: { studentId: string; newLevel: number }[];
  addLevelUp: (studentId: string, newLevel: number) => void;
  clearLevelUp: (studentId: string) => void;

  // Recent star award events (shown as overlay toasts)
  recentStarAwards: StarAwardEvent[];
  addStarAward: (event: StarAwardEvent) => void;
  clearStarAwards: () => void;
}

export const useClassStore = create<ClassState>((set) => ({
  roster: [],
  setRoster: (students) => set({ roster: students }),

  pendingLevelUps: [],
  addLevelUp: (studentId, newLevel) =>
    set((s) => ({
      pendingLevelUps: [
        ...s.pendingLevelUps.filter((lu) => lu.studentId !== studentId),
        { studentId, newLevel },
      ],
    })),
  clearLevelUp: (studentId) =>
    set((s) => ({
      pendingLevelUps: s.pendingLevelUps.filter((lu) => lu.studentId !== studentId),
    })),

  recentStarAwards: [],
  addStarAward: (event) =>
    set((s) => ({ recentStarAwards: [event, ...s.recentStarAwards].slice(0, 10) })),
  clearStarAwards: () => set({ recentStarAwards: [] }),
}));
